import { ViewProduct } from '../models/ViewProduct.model';
import { useSharedGetReviewState } from './actions/useReviewState';

export interface RatingSummary {
  rating: number;
  totalReviews: number;
}

export const useProductRating = (product: ViewProduct | undefined): RatingSummary => {
  const { reviewSet } = useSharedGetReviewState({ itemsPerPage: 5, page: 1, productId: product?.id ?? '0' });
  const averageScore = reviewSet?.bottomline?.average_score ?? 4.8;
  const count = reviewSet?.bottomline?.total_review ?? 0;

  return { rating: averageScore, totalReviews: count };
};
